import React, { FC } from 'react';

import { Svg } from '@lglp/components';

import styles from './SearchIcon.module.scss';

const SearchIcon: FC<SearchIconProps> = ({ className, ...rest }) => {
  return (
    <Svg
      className={[styles.searchIcon, className]}
      viewBox="0 0 27.5 27.5"
      {...rest}
    >
      <path
        className={styles.search1}
        d="M10.88 1a10 10 0 0 1 9.88 10.08 10 10 0 0 1-9.87 10.08A10 10 0 0 1 1 11.08 10 10 0 0 1 10.88 1z"
      />
      <path d="M18 18l8.5 8.5" />
    </Svg>
  );
};

type SearchIconProps = {
  className?: string;
};

export default SearchIcon;
